const SHORT_DOCUMENT_TYPE_LABEL_KEYS: Record<string, string> = {
  DIELINE_DIAGRAM: 'itemDetail.shortDocumentTypes.dielineDiagram',
  PACKAGING_PHOTOS: 'itemDetail.shortDocumentTypes.packagingPhotos',
  LABEL_PHOTOS: 'itemDetail.shortDocumentTypes.labelPhotos',
  SDS_OR_BOM: 'itemDetail.shortDocumentTypes.sdsOrBom',
  HEAVY_METALS_TEST_REPORT:
    'itemDetail.shortDocumentTypes.heavyMetalsTestReport',
  HEAVY_METALS_CONFORMITY_STATEMENT:
    'itemDetail.shortDocumentTypes.heavyMetalsConformityStatement',
  SUBSTANCES_OF_CONCERN_TEST_REPORT:
    'itemDetail.shortDocumentTypes.substancesOfConcernTestReport',
  SUBSTANCES_OF_CONCERN_CONFORMITY_STATEMENT:
    'itemDetail.shortDocumentTypes.substancesOfConcernConformityStatement',
  OTHER: 'itemDetail.shortDocumentTypes.other',
  OTHER_TEST_REPORT: 'itemDetail.shortDocumentTypes.otherTestReport',
}

export function packagingItemShortDocumentTypeLabelKey(
  documentType: string
): string {
  return SHORT_DOCUMENT_TYPE_LABEL_KEYS[documentType] ?? documentType
}
